export default "__VITE_ASSET__BfNK_3e2__"